module.exports = __webpack_public_path__ + "static/img/None.3954b12c.png";